import { getErrorResponse } from 'legacy/lut/functions'

import WebSocketStore from 'core/classes/services/WebSocketStore'
import { TResponse } from 'core/classes/ws/WebSocketClient'

type TRefreshStatusResponse = {
  status: string
}

class OnboardingThirdPartyApi {
  public async refreshProfileStatus(
    actionId: number
  ): Promise<Required<TResponse<TRefreshStatusResponse>>> {
    const wsClient = WebSocketStore.get('onboarding')
    let result
    const failureMessage = 'Failed to refresh status'
    try {
      const response = await wsClient.call<TRefreshStatusResponse>({
        service: 'third-party',
        action: 'refresh-profile-status',
        payload: { actionId },
        withoutTokenRefresh: true,
        isAuth: true,
      })
      let message
      if (response.status === 'success') {
        const successMessage = 'Status is refreshed.'
        message = response.data.status
          ? `${successMessage} Status: ${response.data.status}`
          : successMessage
      } else {
        message = failureMessage
      }
      result = { ...response, message }
    } catch (e: any) {
      result = getErrorResponse<TRefreshStatusResponse>(e || failureMessage, {
        status: '',
      })
    }

    return result
  }
}

export const onboardingThirdPartyApi = new OnboardingThirdPartyApi()
